<!-- 商品列表筛选 -->
<template>
  <div class="container" style="">
    <div class="content">
      <ul class="select-wrap">
        <li
          class="select-wrap-row"
          v-for="(item, index) in filterData"
          :key="index"
          v-show="index < isCurrenLength && item.isShow"
          :style="{ height: isCurrentArray.indexOf(index) != -1 ? 'auto' : '38px' }"
        >
          <div
            class="filter-title-box"
            :style="{ height: isCurrentArray.indexOf(index) != -1 ? 'auto' : '37px' }"
          >
            <span class="pointer ellipsis">{{ item.name }}</span>
            <!-- <el-tooltip  class="item" effect="light" :content="item.name" placement="top" >
                 <span class="pointer ellipsis">{{ item.name }}</span>
              </el-tooltip> -->
          </div>
          <div class="filter-item-box" :style="{ width: widthSet ? '772px' : '600px' }">
            <!-- <ul ref="filer" v-if="!(isActiveIndex === index)" :style="{'max-height':isCurrentArray.indexOf(index)!=-1?'144px':'38px','overflow-y':isCurrentArray.indexOf(index)!=-1?'auto':'hidden'}"> -->
            <ul
              ref="filer"
              v-if="!(isActiveIndex === index)"
              :style="{
                'max-height': isCurrentArray.indexOf(index) != -1 ? '500px' : '38px',
                'overflow-y': isCurrentArray.indexOf(index) != -1 ? 'auto' : 'hidden',
              }"
            >
              <li class="no-limit pointer">不限</li>
              <li
                ref="limit"
                v-show="item.type == 'attr' || item.type == 'spec'"
                class="filter-item pointer"
                v-for="(value, index) in item.fitem"
                :key="'10' + index"
                @click="selectItem(item.type, value, item.name)"
              >
                {{ value.value }}
              </li>
              <!-- <li>{{item.fitem}}</li> -->
              <li
                v-show="item.type == 'cate' || item.type == 'brand'"
                class="filter-item pointer"
                v-for="(value, index) in item.fitem"
                :key="'20' + index"
                @click="selectItem(item.type, value, item.name)"
              >
                <span>{{ value }}</span>
              </li>
            </ul>
            <div style="display:flex;flex-flow: column;">
              <ul
                v-if="isActiveIndex === index"
                class="mulit-select-wrap"
                :style="{
                  'max-height': isActiveIndex === index ? '500px' : '',
                  'overflow-y': isActiveIndex === index ? 'auto' : 'hidden',
                }"
              >
                <li
                  v-show="item.type == 'attr' || item.type == 'spec'"
                  class="filter-item pointer"
                  v-for="(value, index) in item.fitem"
                  :key="'30' + index"
                  @click="selectMultItem(item.type, value.value, item.name)"
                >
                  <p class="mult-box">
                    <i class="check-box-em"></i>
                    <i
                      v-show="multiArr.indexOf(item.name + '_' + value.value) != -1"
                      class="check-box-hook"
                    ></i>
                    <span>{{ value.value }}</span>
                  </p>
                </li>
                <li
                  v-show="item.type == 'cate' || item.type == 'brand'"
                  class="filter-item pointer"
                  v-for="(value, index) in item.fitem"
                  :key="'40' + index"
                  @click="selectMultItem(item.type, value, item.name)"
                >
                  <p class="mult-box">
                    <i class="check-box-em"></i>
                    <i v-show="multiArr.indexOf(value) != -1" class="check-box-hook"></i>
                    <span>{{ value }}</span>
                  </p>
                </li>
                <!-- <li class="mult-wrap">
                     <div class="mult-confirm other-btn" @click="cancelMultSelect">取消</div>
                      <div class="mult-confirm other-btn" @click="confirmSearch(index)">确定</div>
                </li> -->
              </ul>
              <div class="mult-wrap" v-if="isActiveIndex === index">
                <div class="mult-confirm other-btn" @click="cancelMultSelect">取消</div>
                <div class="mult-confirm other-btn" @click="confirmSearch(index)">确定</div>
              </div>
            </div>
          </div>
          <div class="filter-handle-box">
            <div
              class="select-more pointer"
              v-show="item.type != 'cate' && item.fitem.length > 1"
              @click="showMoreClickItem(index)"
            >
              多选
              <img class="default" src="~@/assets/img/purchase/icon-plus-default@2x.png" alt="" />
              <img class="color" src="~@/assets/img/purchase/icon-plus-color@2x.png" alt="" />
            </div>
            <div
              class="select-open pointer"
              v-show="item.width >= 772"
              :class="[isCurrentArray.indexOf(index) != -1 ? 'open-up' : 'open-down']"
              @click="showMoreIem(index)"
            >
              {{ isCurrentArray.indexOf(index) != -1 ? '收起' : '更多' }}
              <!-- <img src="" alt=""> -->
            </div>
          </div>
        </li>
      </ul>
      <div class="more-item pointer" v-show="filterData.length > 4" @click="showMoreLine">
        <span>{{ isShowMoreItem ? '更多筛选条件' : '收起' }}</span>
        <img
          :style="{ transform: isShowMoreItem ? '' : 'rotate(180deg)' }"
          src="~@/assets/img/purchase/icon-item-more-1.png"
          alt=""
        />
      </div>
    </div>
  </div>
</template>

<script>
import utils from '@/modules/projectA/utils/utils';
export default {
  props: {
    filterData: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      isShowMoreItem: true,
      isCurrentArray: [], //当前展开行数组
      isCurrenLength: 4, //当前展示行数
      isActiveIndex: null,
      multiArr: [], //多选数组
      type: null,
      filterName: null,
      widthSet: true,
    };
  },

  components: {},

  computed: {},

  created() {
    //  console.log('1')
    //  this.getWidthEle();
  },
  mounted() {
    let pathArr = ['/demand/execute/selectGoods', '/plan/purchaseWayExecute/selectGoods'];
    this.widthSet = pathArr.includes(this.$route.path) ? false : true;
  },
  watch: {
    filterData: {
      handler(newVal, oldVal) {
        if (newVal.length > 0) {
          this.getWidthEle();
        }
      },
      deep: true,
    },
  },
  methods: {
    // 获取宽度
    getWidthEle() {
      //   let width = 0;
      // for(let i=0;i<arr.length;i++){
      //   console.log(this.$refs['filer-item-box'+i].$el.clientWidth);
      //    width = (this.$refs['filer-item-box'+i].$el.clientWidth)
      //   width+=width;
      // }

      this.$nextTick(() => {
        // console.log(this.$refs.filer);
        let arr = this.$refs.filer;
        for (let i = 0; i < arr.length; i++) {
          // this.filterData[i].width = arr[i].clientWidth
          this.$set(this.filterData[i], 'width', arr[i].clientWidth);
          //  console.log(arr[i].clientWidth);
        }
        // console.log( this.filterData);
      });
    },
    showMoreClickItem(index) {
      this.isCurrentArray.length = 0;
      this.isCurrentArray.push(index);
      this.isActiveIndex = index;
      this.multiArr = [];
      //  console.log(this.isCurrentArray);
    },
    showMoreIem(index) {
      let isHasItem = this.isCurrentArray.indexOf(index);
      console.log(isHasItem);
      if (isHasItem != -1) {
        this.isCurrentArray.splice(isHasItem, 1);
      } else {
        this.isCurrentArray.length = 0;
        this.isCurrentArray.push(index);
      }
      this.isActiveIndex = null;
      //  console.log(this.isCurrentArray);
    },
    showMoreLine() {
      this.isShowMoreItem = !this.isShowMoreItem;
      if (this.isShowMoreItem) {
        this.isCurrenLength = 4;
      } else {
        this.isCurrenLength = this.filterData.length;
      }
      this.getWidthEle();
    },
    selectItem(type, val, filterName) {
      // console.log(type);
      //  console.log(val);
      //   console.log(filterName);
      this.$emit('selectItem', { type, val, filterName });
    },
    selectMultItem(type, val, filterName) {
      let name = null;
      if (type == 'brand') {
        name = val;
      } else {
        name = filterName + '_' + val;
      }
      this.type = type;
      this.filterName = filterName;
      if (utils.checkDuplicateAttr(this.multiArr, name) != -1) {
        this.multiArr.splice(utils.checkDuplicateAttr(this.multiArr, name), 1);
      } else {
        this.multiArr.push(name);
      }
      console.log(this.multiArr);
    },
    confirmSearch(index) {
      console.log(index);
      if (this.multiArr.length == 0) return;
      this.isActiveIndex = null;
      this.$emit('selectMultItem', {
        multiArr: this.multiArr,
        type: this.type,
        name: this.filterName,
      });
    },
    cancelMultSelect() {
      this.isActiveIndex = null;
      this.multiArr.length = 0;
      this.isCurrentArray.length = 0;
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/css/mixin/flex.scss';
@import '@/assets/css/theme.scss';
.container {
  width: 100%;
  background: #fff;
  // margin-top: 10px;
  .content {
    /*width: 1200px;*/
    margin: 0 auto 40px auto;
    position: relative;

    .more-item {
      position: absolute;
      left: 50%;
      margin-left: -73px;
      // top: -1px;
      bottom: -29px;
      width: 146px;
      height: 30px;
      color: #666;
      font-size: 14px;
      border-top: 1px solid #fff;
      border-left: 1px solid #d9d9d9;
      border-right: 1px solid #d9d9d9;
      border-bottom: 1px solid #d9d9d9;
      @include flex(center, center, row);
      span {
        color: #666;
        font-size: 12px;
        &:hover {
          color: $main-col;
        }
      }
      img {
        width: 12px;
        height: 12px;
        margin-left: 10px;
      }
    }
  }
  .select-wrap {
    // margin-top: 20px;
    border-top: 1px solid #d9d9d9;
    border-left: 1px solid #d9d9d9;
    border-right: 1px solid #d9d9d9;
    .select-wrap-row {
      // height: 44px;
      display: flex;
      flex-flow: row;
      border-bottom: 1px solid #d9d9d9;
      .filter-item-box {
        width: 772px;
        display: flex;
        align-items: center;
        // flex-flow: column;
        ul {
          display: flex;
          flex-wrap: wrap;
          overflow: hidden;
          padding-left: 20px;
          // overflow-y: auto;
          // width: 100%;
          li {
            height: 38px;
            line-height: 38px;
          }
        }
        .no-limit {
          margin-right: 20px;
          font-size: 12px;
          font-family: SourceHanSansCN-Regular, SourceHanSansCN;
          font-weight: 400;
          color: #ff0000;
        }
        .filter-item {
          margin-right: 20px;
          font-size: 12px;
          color: #666;
          &:hover {
            color: $main-col;
            i {
              border: 1px solid $main-col;
            }
          }
          p {
            span {
              &:hover {
                color: $main-col;
              }
            }
          }
        }
        .check-box-em {
          width: 18px;
          height: 18px;
          border: 1px solid #d9d9d9;
          display: inline-block;
        }
        .check-box-hook {
          display: inline-block;
          width: 18px;
          height: 18px;
          top: 10px;
          left: 0px;
          position: absolute;
          background: url('~@/assets/img/purchase/icon-select1@2x.png') no-repeat center center;
          background-size: 18px;
        }
        .mult-box {
          display: flex;
          align-items: center;
          position: relative;
          span {
            font-size: 12px;
            color: #666;
            margin-left: 10px;
          }
        }
        .mult-wrap {
          display: flex;
          justify-content: center;
          width: 100%;
          margin: 20px auto 10px auto;
          div {
            width: 54px;
            height: 24px;
            border: 1px solid #ddd;
            color: #666;
            cursor: pointer;
            font-size: 12px;
            line-height: 22px;
            text-align: center;
            margin-right: 10px;
          }
        }
      }
    }
    .filter-handle-box {
      display: flex;
      margin-left: 160px;
      // align-items: center;
      margin-top: 5px;
      width: 114px;
      justify-content: flex-end;
      .select-more {
        border: 1px solid #d9d9d9;
        width: 52px;
        height: 24px;
        padding: 0 7px;
        font-size: 12px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #666;
        // background: url("~@/assets/img/purchase/select-more@2x.png") no-repeat 36px 50%;
        // background-size: 12px;
        line-height: 22px;
        i {
          font-size: 12px;
        }
        img {
          width: 9px;
          float: right;
          margin-top: 6px;
        }
        .default {
          display: inline-block;
        }
        .color {
          display: none;
        }
        &:hover {
          border: 1px solid $main-col;
          color: $main-col;
          .default {
            display: none;
          }
          .color {
            display: inline-block;
          }
        }
      }
      .select-open {
        margin-left: 10px;
        border: 1px solid #d9d9d9;
        width: 52px;
        height: 24px;
        // padding: 0 10px;
        font-size: 12px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #666;
        line-height: 22px;
        padding-left: 6px;
        &.open-up {
          background: url('~@/assets/img/purchase/select-open1@2x.png') no-repeat 36px 50%;
          background-size: 10px;
          &:hover {
            border: 1px solid $main-col;
            color: $main-col;
            background: url('~@/assets/img/purchase/select-open-up-hover1@2x.png') no-repeat 36px
              50%;
            background-size: 10px;
          }
        }
        &.open-down {
          background: url('~@/assets/img/purchase/select-open-down1@2x.png') no-repeat 36px 50%;
          background-size: 10px;
          &:hover {
            border: 1px solid $main-col;
            color: $main-col;
            background: url('~@/assets/img/purchase/select-open-down-hover@2x.png') no-repeat 36px
              34%;
            background-size: 10px;
          }
        }
      }
    }
    .filter-title-box {
      width: 130px;
      height: 38px;
      background: #f5f5f5;
      display: flex;
      line-height: 38px;
      text-align: left;
      padding-left: 20px;
      span {
        font-size: 12px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #666;
      }
    }
  }
  .mulit-select-wrap {
    width: 772px;
  }
}
</style>
